import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const createKey = (requestId) => ['check_payment_state', requestId];

const checkPaymentState = async (requestId) =>
  request.get(
    `Request/check_payment_state/${requestId}`,
    {},
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );

export const useCheckPaymentState = (requestId, options) =>
  useQuery(createKey(requestId), () => checkPaymentState(requestId), options);
